import provincesList from './provincesList'

export default class Province {
    constructor() {
    }

    static list(map = false, notaries = null) {
        if (map && notaries) {
            this.mapNotaries(notaries)
        }
        return provincesList
    }

    static listName () {
        return provincesList.map( (p) => p.name)
    }

    static mapNotaries (notaries) {
        notaries.map( (notary) => {
            let listProvincesName = this.listName()
            let index = listProvincesName.indexOf(notary.address_gmaps.province)
            if (index !== -1) {
                if (provincesList[index].hasOwnProperty('notaries')) provincesList[index].notaries.push(notary)
            }
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/factories/province/index.js